'use strict';

export class PhoneAbuse {
	constructor($root) {
		
		/**
		 * Internal state
		 */
		this.valid_msg_id = false;
		this.msg_id       = "";
		this.file         = null;
		this.email        = "";
		this.phone        = "";
		this.has_pf      = false;
		this.$root = $root;

		/**
		 * Cache jQuery elements
		 */
		this.$phone_abuse_input   = this.$root.find(".js-faqpa_phone_abuse_input");
		this.$input_ad_id         = this.$root.find(".js-faqpa_input_ad_id");
		this.$wrong_id_no_button  = this.$root.find(".js-faqpa_wrong_id_no_button");
		this.$input_email         = this.$root.find(".js-faqpa_input_email");
		this.$input_phone         = this.$root.find(".js-faqpa_input_phone");
		this.$form_ad_id          = this.$root.find(".js-faqpa_form_ad_id");
		this.$form_phone          = this.$root.find(".js-faqpa_form_phone");
		this.$all_submit_buttons  = this.$root.find(".js-faqpa_submit_button");
		this.$information_check   = this.$root.find(".js-faqpa_information_check");
		this.$upload_proof        = this.$root.find(".js-faqpa_upload_proof");
		this.$input_proof_file    = this.$root.find(".js-faqpa_input_proof_file");
		this.$yes_no_buttons      = this.$root.find(".js-faqpa_yes_no_buttons");
		this.$back_to_locanto     = this.$root.find(".js-faqpa_back_to_locanto");
		this.$feedback_wrapper    = this.$root.find(".js-faq_meta_results__question.active")
									 .find(".js-faq_meta_results__feedback_wrapper");

		this._original_form_html = this.$root.html();

		// Hide initially feedback wrapper
		yalwa.basics.hide(this.$feedback_wrapper);

		/**
		 * Map form 'data-type' to handler methods
		 */
		this.actions = {
			"ad-id": this.handle_ad_id_submission.bind(this),
			"email": this.handle_email_submission.bind(this),
			"phone": this.handle_phone_submission.bind(this)
		};

		/**
		 * Initialize all event listeners
		 */
		this.init_event_listeners();
	}

	/**
	 * Organize all event bindings here.
	 */
	init_event_listeners() {

		// File upload button & file selection (scoped to visible form)
		const $visible_form = this.$root;
		
		// Clicking "Yes" -> user knows Ad ID
		this.$root.find(".js-faqpa_know_ad_id").on("click", this.show_ad_id_form.bind(this));
		// Clicking "No" -> user has phone number
		this.$root.find(".js-faqpa_dont_know_ad_id").on("click", this.show_phone_form.bind(this));

		// "No" -> user does NOT want to correct the ID/phone
		this.$root.find(".js-faqpa_wrong_id_no").on("click", this.handle_wrong_id_no.bind(this));
		// "Yes" -> user DOES want to correct the ID/phone
		this.$root.find(".js-faqpa_wrong_id_yes").on("click", () => this.reset_form());

		// Input validation on every keystroke
		this.$phone_abuse_input.on("input", this.validate_input.bind(this));
		// Show sublebel on focus
		this.$phone_abuse_input.on("focus", function() {
			yalwa.basics.show(jQuery(this).parent().next());
		});
		// Press 'Enter' triggers the correct form action
		this.$phone_abuse_input.on("enterdown", this.handle_submit_input.bind(this));

		// Any "Submit" button
		this.$all_submit_buttons.on("click", this.handle_submit_input.bind(this));

		// File upload button & file selection
		$visible_form.find(".js-faqpa_upload_proof")
			.on("click", () => {
				$visible_form.find(".js-faqpa_input_proof_file").click();
			});

		$visible_form.find(".js-faqpa_input_proof_file")
			.on("change", this.handle_file_change.bind(this));
	}

	/**
	 * Show form to enter Ad ID
	 */
	show_ad_id_form() {
		yalwa.basics.show(this.$form_ad_id);
		yalwa.basics.show(this.$root.find(".js-faqpa_faq_phone_yes"));
		yalwa.basics.hide(this.$yes_no_buttons);
	}

	/**
	 * Show form to enter phone number
	 */
	show_phone_form() {
		yalwa.basics.show(this.$form_phone);
		yalwa.basics.show(this.$root.find(".js-faqpa_faq_phone_no"));
		yalwa.basics.hide(this.$yes_no_buttons);
	}

	/**
	 * User chooses "No" to correct ID/phone -> show "try again" message
	 */
	handle_wrong_id_no(e) {
		yalwa.basics.hide(this.$wrong_id_no_button);
		yalwa.basics.show(this.$root.find(".js-faqpa_faq_phone_try_again_no"));
		yalwa.basics.show(this.$back_to_locanto);
		yalwa.basics.show(this.$feedback_wrapper);
	}

reset_form() {
		console.log('[PhoneAbuse] reset_form');
		this.$root.html(this._original_form_html);

		this.$phone_abuse_input   = this.$root.find(".js-faqpa_phone_abuse_input");
		this.$input_ad_id         = this.$root.find(".js-faqpa_input_ad_id");
		this.$wrong_id_no_button  = this.$root.find(".js-faqpa_wrong_id_no_button");
		this.$input_email         = this.$root.find(".js-faqpa_input_email");
		this.$input_phone         = this.$root.find(".js-faqpa_input_phone");
		this.$form_ad_id          = this.$root.find(".js-faqpa_form_ad_id");
		this.$form_phone          = this.$root.find(".js-faqpa_form_phone");
		this.$all_submit_buttons  = this.$root.find(".js-faqpa_submit_button");
		this.$information_check   = this.$root.find(".js-faqpa_information_check");
		this.$upload_proof        = this.$root.find(".js-faqpa_upload_proof");
		this.$input_proof_file    = this.$root.find(".js-faqpa_input_proof_file");
		this.$yes_no_buttons      = this.$root.find(".js-faqpa_yes_no_buttons");
		this.$back_to_locanto     = this.$root.find(".js-faqpa_back_to_locanto");

		this.valid_msg_id = false;
		this.msg_id = "";
		this.phone = "";
		this.email = "";

		this.init_event_listeners();
	}

	/**
	 * Validate input whenever user types in an ad ID or email.
	 */
	validate_input(e) {
		const $input             = jQuery(e.currentTarget);
		const input_value        = $input.val().trim();
		const input_type         = $input.attr("type");
		const $parent_div        = $input.parent().parent();
		const $input_submit_btn  = $input.next();

		let is_valid = false;

		if (input_type === "text") {
			// Only digits allowed and minimum 6 digits
			is_valid = /^\d+$/.test(input_value);
		} else if (input_type === "email") {
			// Basic email format check
			is_valid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(input_value);
		}

		this.valid_msg_id = is_valid;
		$parent_div.toggleClass("phone_abuse_error", !is_valid);
		yalwa.basics.toggle($input_submit_btn, is_valid);
	}

	/**
	 * Clicking on a "Submit" button (Or Enter inside input) determines which action to call (ad-id, email, phone).
	 */
	handle_submit_input(e) {
		this.actions[jQuery(e.currentTarget).parent().data("type")]?.(e);
	}

	/**
	 * Handle submission when the user enters Ad ID.
	 */
	handle_ad_id_submission(e) {

		//Without this line, the form will hidden by parent listener
		e.stopPropagation();

		if (!this.valid_msg_id) {
			return;
		}

		this.msg_id = this.$input_ad_id.val().trim();
		const $parent_div = jQuery(e.currentTarget).parent();

		// Display the submitted Ad ID
		$parent_div.html(`
			<div class="faq_phone_abuse_form__question_section_answer">
				${this.msg_id}
			</div>
		`);

		yalwa.basics.hide($parent_div.next());
		yalwa.basics.show(this.$information_check);

		jQuery.ajax({
			type: 'POST',
			url: '/api/ajax/general/',
			dataType: 'json',
			data: {
				action: 'phone_checking_faq',
				msgID: this.msg_id,
				sub_action: 'validate_ad_id',
				csrf_bust: yalwa.v.csrf_bust
			}
		}).done((response) => {
			setTimeout(() => {
				if (response.success) {
					if (response.premium) {
						this.has_pf = true;                        
					}
					const target_class = ".js-faqpa_proof_upload_section";
					yalwa.basics.show(jQuery(target_class));
				} else {
					yalwa.basics.show(this.$root.find(".js-faqpa_wrong_ad_id"));
					if (response.phone_not_found) {
						yalwa.basics.show(this.$root.find(".js-faqpa_phone_number_not_found"));
					} else {
						yalwa.basics.show(this.$root.find(".js-faqpa_posting_not_found"));
					}
				}
			}, 2000);
		});
	}

	/**
	 * Handle submission when the user enters an email address.
	 */
	handle_email_submission(e) {
		
		this.email = this.$input_email.val().trim();

		const is_valid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.email);
		
		if (!is_valid) {
			return;
		}

		const $parent_div = jQuery(e.currentTarget).parent();
		const form_data   = new FormData();

		// Only append msgID or phone if they exist
		if (this.msg_id)  form_data.append("msgID", this.msg_id);
		if (this.phone)   form_data.append("phone", this.phone);

		// Additional form data
		form_data.append("c", "b2_11");
		form_data.append("file", this.file);
		form_data.append("message", "Phone number abuse");
		form_data.append("email", this.email);
		form_data.append("action", "phone_checking_faq");
		form_data.append("sub_action", "send_message");
		form_data.append("csrf_bust", yalwa.v.csrf_bust);

		jQuery.ajax({
			type: "POST",
			url: "/api/ajax/general/",
			data: form_data,
			processData: false,
			contentType: false,
			dataType: "json",
		}).done((response) => {
			const $upload_status = this.$root.find(".js-faqpa_upload_status");
			if (response.success) {
				$parent_div.html(`
					<div class="faq_phone_abuse_form__question_section_answer">
						${this.email}
					</div>
				`);
				yalwa.basics.show(this.$root.find(".js-faqpa_thank_you_for_email"));
				yalwa.basics.show(this.$back_to_locanto);
				yalwa.basics.show(this.$feedback_wrapper);
			} else {
				$upload_status
					.text("Upload failed. Please try again.")
					.css("color", "red");
			}
		});
	}

	/**
	 * Handle submission when the user enters a phone number.
	 */
	handle_phone_submission(e) {
		
		e.stopPropagation();

		this.phone = this.$input_phone.val().trim();

		if (!this.valid_msg_id) {
			return;
		}

		if (this.phone.length < 6) {
			// Handle case where phone number is too short
			let $label = jQuery('.js-faqpa_phone_is_short').html();            
			yalwa.basics.toast({message: $label, type: 'error'});
			return
		}
		
		const $parent_div = jQuery(e.currentTarget).parent();

		yalwa.basics.show(this.$information_check);
		yalwa.basics.hide($parent_div.next());

		$parent_div.html(`
			<div class="faq_phone_abuse_form__question_section_answer">
				${this.phone}
			</div>
		`);

		jQuery.ajax({
			type: 'POST',

			url: '/api/ajax/general/',
			dataType: 'json',
			data: {
				action: 'phone_checking_faq',
				phone: this.phone,
				sub_action: 'validate_phone',
				csrf_bust: yalwa.v.csrf_bust
			}
		}).done((response) => {
			setTimeout(() => {
				if (response.success) {
					if (response.premium) {
						this.has_pf = true;
					}
					const target_class = ".js-faqpa_proof_upload_section";
					yalwa.basics.show(jQuery(target_class));
				} else {
					yalwa.basics.show(this.$root.find(".js-faqpa_wrong_ad_id"));
					yalwa.basics.show(this.$root.find(".js-faqpa_posting_not_found"));
				}
			}, 2000);
		});
	}

	/**
	 * Handle file selection for proof upload
	 */
	handle_file_change() {

		this.file = this.$input_proof_file[0]?.files?.[0];   

		if (!this.file) return;

		const form_data   = new FormData();

		if (this.msg_id)  form_data.append("msgID", this.msg_id);
		if (this.phone)   form_data.append("phone", this.phone);

		form_data.append("c", "b2_11");
		form_data.append("file", this.file);
		form_data.append("message", "Phone number abuse");
		form_data.append("action", "phone_checking_faq");
		form_data.append("sub_action", "file_upload");
		form_data.append("csrf_bust", yalwa.v.csrf_bust);

		jQuery.ajax({
			type: "POST",
			url: "/api/ajax/general/",
			data: form_data,
			processData: false,
			contentType: false,
			dataType: "json",
		}).done((response) => {
			setTimeout(() => {

				const $upload_button_text = jQuery(".js-faqpa_upload_proof span");
				$upload_button_text.text(this.file.name);
		
				this.$upload_proof.addClass("upload-button--uploaded");
				yalwa.basics.hide(this.$upload_proof.prev());
		
				if (!this.has_pf) {
					yalwa.basics.show(this.$root.find(".js-faqpa_free_ads"));
					yalwa.basics.show(this.$back_to_locanto);
					yalwa.basics.show(this.$feedback_wrapper);
				} else {
					yalwa.basics.show(this.$root.find(".js-faqpa_information_verified"));
				}

			}, 2000);
		});

		
	}
}